const Temperature = {
  Celsius: "celsius",
  Fahrenheit: "fahrenheit",
};

export default Object.freeze(Temperature);
